import React from "react";
import styled from "styled-components";
import { Spinner, Table as BsTable } from "react-bootstrap";
import { ItemListadoMascotasReservas } from "../../../../services/reservasGuarderiaServicios";

function Table({
  mascotas,
  onRowClick,
  isLoading,
  isSuccess,
}: {
  mascotas: ItemListadoMascotasReservas[];
  onRowClick: (itemListadoMascotaReservas: ItemListadoMascotasReservas) => void;
  isLoading: boolean;
  isSuccess: boolean;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Nombre</StyledColHeader>
          <StyledColHeader>Raza</StyledColHeader>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Documento</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {isLoading && <LoadingItem />}
        {isSuccess &&
          mascotas.map((_) => (
            <TableItem key={_.id} mascota={_} onRowClick={onRowClick} />
          ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  mascota,
  onRowClick,
}: {
  mascota: ItemListadoMascotasReservas;
  onRowClick: (itemListadoMascotaReservas: ItemListadoMascotasReservas) => void;
}) {
  return (
    <StyledRow onClick={() => onRowClick(mascota)}>
      <StyledCell>{mascota.nombre}</StyledCell>
      <StyledCell>{mascota.raza}</StyledCell>
      <StyledCell>{mascota.nombresPropietario}</StyledCell>
      <StyledCell>{mascota.documentoPropietario}</StyledCell>
    </StyledRow>
  );
}

function LoadingCell() {
  return (
    <StyledCell>
      <Spinner animation={"border"} />
    </StyledCell>
  );
}

function LoadingItem() {
  return (
    <StyledRow>
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
